import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/auth";
import { errorText } from "@/lib/errors";

export const useAdminList = (path) => {
  const [items, setItems] = useState(null);
  const reload = useCallback(async () => {
    try {
      setItems((await adminApi.get(path)).data);
    } catch (err) {
      toast.error(errorText(err));
      setItems([]);
    }
  }, [path]);
  useEffect(() => { reload(); }, [reload]);
  return { items, reload };
};

export const Empty = ({ children, testId }) => (
  <div className="rounded-2xl border border-dashed border-pine/30 p-10 text-moss" data-testid={testId}>{children}</div>
);

export const Loading = () => <p className="text-moss" data-testid="admin-list-loading">Loading...</p>;

export const when = (iso) =>
  new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });

export const Mail = ({ to }) => (
  <a href={`mailto:${to}`} className="underline underline-offset-4 decoration-brass break-all">{to}</a>
);
